// extracted by mini-css-extract-plugin
export default {"page-title":"CreateBooking_page-title__Oo4sO"};